export default __webpack_public_path__ + "static/advancedSearch-bb17be5a53515afe809a6ea526bd8f88.gif";